module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-cefcf984c1444216f5d2c48a18b38754.jpg";